import useIntl from '@/utils/intl'
import { resolveImageUrl } from '@/utils/constants'
import Image from 'next/image'

interface PricePackageProps {
  data: Array<{
    id: string
    nameEn: string
    nameMn: string
    icon: string
    roaming_zone?: {
      nameEn: string
      nameMn: string
    }
    price_package?: {
      Inland: string
      toMongolia: string
      otherCountry: string
      outMessage: string
      incomingCall: string
    }
  }>
  selectedService: string | null
  locale: 'en' | 'mn'
  IMG_URL: string
}

const PricePackage: React.FC<PricePackageProps> = ({ data, selectedService, locale, IMG_URL }) => {
  const { translate } = useIntl()

  const filteredData = selectedService != null
    ? data.filter((item) => item.id === selectedService)
    : data

  return (
    <>
      <table className="hidden xl:block w-full text-sm text-left rtl:text-right">
        <thead className="text-xs uppercase bg-surfaceLow">
          <tr>
            <th scope="col" className="px-6 py-3 text-center">{translate('roamingRegion')}</th>
            <th scope="col" className="px-6 py-3 text-center">{translate('roamingCountry')}</th>
            <th scope="col" className="px-6 py-3 text-center">{translate('roamingDomesticCall')}</th>
            <th scope="col" className="px-6 py-3 text-center">{translate('roamingToMongolia')}</th>
            <th scope="col" className="px-6 py-3 text-center">{translate('roamingOtherCounties')}</th>
            <th scope="col" className="px-6 py-3 text-center">{translate('roamingOffnetMessage')}</th>
            <th scope="col" className="px-6 py-3 text-center">{translate('roamingIncomingCalls')}</th>
          </tr>
        </thead>
        <tbody>
          {
            filteredData?.length > 0
              ? (
                filteredData.map((item, index) => (
                  <tr key={index} className="border-b border-secondaryMidStroke">
                    <th scope="row" className="px-6 py-4 whitespace-nowrap ">
                      <h1 className='text-center font-normal'>
                        {locale === 'en' ? item?.roaming_zone?.nameEn : item?.roaming_zone?.nameMn}
                      </h1>
                    </th>
                    <td className="px-6 py-4">
                      <div className="ps-3 ml-5 flex items-center justify-start space-x-5">
                        <Image className="w-10 h-10 rounded-full" alt='' width={10} height={10} src={resolveImageUrl(item.icon)} />
                        <div className="font-normal text-start">
                          {locale === 'en' ? item.nameEn : item.nameMn ?? 'No Name'}
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <div className="h-2.5 w-2.5 rounded-full"></div> {item.price_package?.Inland}
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <div className="h-2.5 w-2.5 rounded-full"></div> {item.price_package?.toMongolia}
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <div className="h-2.5 w-2.5 rounded-full"></div> {item.price_package?.otherCountry}
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <div className="h-2.5 w-2.5 rounded-full"></div> {item.price_package?.outMessage}
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <div className="h-2.5 w-2.5 rounded-full"></div> {item.price_package?.incomingCall}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (<></>)
          }
        </tbody>
      </table>
      {filteredData?.length > 0
        ? (
          filteredData.map((item, index) => (
            <div key={index} className=''>
              <div className='block xl:hidden'>
                <div key={index} className='flex space-y-5 flex-col border border-secondaryMidStroke my-5 rounded-xl'>
                  <div className='flex justify-between rounded-t-xl items-center bg-surfaceLow p-5'>
                    <h1 className='text-center'>{item?.roaming_zone?.nameMn}</h1>
                    <div className='flex justify-center items-center space-x-2'>
                      <Image className=' rounded-full' alt='' width={30} height={30} src={resolveImageUrl(item.icon)} />
                      <h1 className='text-center'>{locale === 'en' ? item.nameEn : item.nameMn ?? 'No Name'}</h1>
                    </div>
                  </div>
                  <div className='flex items-center w-full'>
                    <div className='w-full px-5'>
                      <div className='flex justify-between items-center'>
                        <h1 className='w-44'>{translate('roamingDomesticCall')}</h1>
                        <h1 className=''>{item.price_package?.Inland}</h1>
                      </div>
                      <div className='flex justify-between items-center my-5'>
                        <h1 className=''>{translate('roamingToMongolia')}</h1>
                        <h1 className=''>{item.price_package?.toMongolia}</h1>
                      </div>
                      <div className='flex justify-between items-center my-5'>
                        <h1 className=''>{translate('roamingOtherCounties')}</h1>
                        <h1 className=''>{item.price_package?.otherCountry}</h1>
                      </div>
                      <div className='flex justify-between items-center my-5'>
                        <h1 className=''>{translate('roamingOffnetMessage')}</h1>
                        <h1 className=''>{item.price_package?.outMessage}</h1>
                      </div>
                      <div className='flex justify-between items-center my-5'>
                        <h1 className=''>{translate('roamingIncomingCalls')}</h1>
                        <h1 className=''>{item.price_package?.incomingCall}</h1>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        )
        : (
          <p>No packages available</p>
        )}
    </>
  )
}

export default PricePackage
